import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DistributionDefinitionEntity } from './distribution-definition.entity';

@Index(
	'_distribution_history__fk_distribution_definition__id_fk',
	['fkDistributionDefinitionId'],
	{},
)
@Index('_distribution_history__resourceId_index', ['resourceId'], {})
@Entity('_distribution_history')
export class DistributionHistoryEntity extends BaseEntity {
	@Column('varchar', { name: '_resourceId', length: 64 })
	public resourceId!: string;

	@Column('varchar', { name: '_assigneeId_old', nullable: true, length: 64 })
	public assigneeIdOld!: string | null;

	@Column('varchar', { name: '_assigneeId_new', nullable: true, length: 64 })
	public assigneeIdNew!: string | null;

	@Column('int', {
		name: '_fk__distribution_definition__id',
		nullable: true,
		unsigned: true,
	})
	public fkDistributionDefinitionId!: number | null;

	@ManyToOne(
		() => DistributionDefinitionEntity,
		(distributionDefinition) => distributionDefinition.distributionHistories,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk__distribution_definition__id', referencedColumnName: 'id' },
	])
	public fkDistributionDefinition!: DistributionDefinitionEntity;
}
